/**
 * Clientes que aparecen en las franjas de logos (Home y Casos de Éxito).
 * La lista vive aquí una sola vez para que todas las franjas compartan los
 * mismos dominios: un dominio que no responde deja la tarjeta sin logo.
 * El dominio es el que se usa para recuperar el logo del cliente.
 */
export const CLIENT_LOGOS = [
  { name: 'FC Barcelona', domain: 'fcbarcelona.com' },
  { name: 'Burger King', domain: 'burgerking.com' },
  { name: 'Hugo Boss', domain: 'hugoboss.com' },
  { name: 'Lacoste', domain: 'lacoste.com' },
  { name: 'Tous', domain: 'tous.com' },
  { name: "Levi's", domain: 'levi.com' },
  { name: 'CaixaBank', domain: 'caixabank.es' },
  { name: 'AENA', domain: 'www.aena.es' },
  { name: 'Sodexo', domain: 'sodexo.com' },
  { name: 'Áreas', domain: 'areas.es' },
  { name: 'PortAventura', domain: 'portaventuraworld.com' },
  { name: 'Fira Barcelona', domain: 'firabarcelona.com' },
  { name: 'Pacha', domain: 'pacha.com' },
  { name: 'Poble Espanyol', domain: 'poble-espanyol.com' },
  { name: 'Zoo Barcelona', domain: 'zoobarcelona.cat' },
  { name: 'Tibidabo', domain: 'tibidabo.cat' },
  { name: 'Park Güell', domain: 'parkguell.barcelona' },
  { name: 'Grupo Nomo', domain: 'gruponomo.com' },
];